import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'portal-progress-bar',
	template: `
		<div class="portal-progress-bar">
			<div class="portal-progress-bar-seg portal-progress-bar-paid" [style.width.%]="pct(paid)"></div>
			<div class="portal-progress-bar-seg portal-progress-bar-due" [style.width.%]="pct(toPay)"></div>
		</div>
	`,
	encapsulation: ViewEncapsulation.None,
	host: {
		'[class.portal-progress-bar-sm]': "size === 'sm'",
		'[class.portal-progress-bar-md]': "size === 'md'",
		'[class.portal-progress-bar-lg]': "size === 'lg'"
	},
	styles: [`
		portal-progress-bar {
			display: block;
			flex-shrink: 0;
		}

		portal-progress-bar.portal-progress-bar-sm { height: 0.25rem; }
		portal-progress-bar.portal-progress-bar-md { height: 0.75rem; }
		portal-progress-bar.portal-progress-bar-lg { height: 0.8rem; }

		.portal-progress-bar {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
			background: var(--c-bar-track);
			border-radius: 0.2rem;
		}

		portal-progress-bar.portal-progress-bar-md .portal-progress-bar {
			border-radius: 0.1rem;
		}

		portal-progress-bar.portal-progress-bar-md .portal-progress-bar-seg {
			min-width: 0.1rem;
		}

		.portal-progress-bar-seg {
			height: 100%;
		}

		.portal-progress-bar-paid {
			background: var(--c-success-solid);
		}

		.portal-progress-bar-due {
			background: var(--c-primary-solid);
		}
	`]
})
export class PortalProgressBarComponent {
	@Input() paid = 0;
	@Input() toPay = 0;
	@Input() total = 0;
	@Input() size: 'sm' | 'md' | 'lg' = 'lg';

	// A value's share of the total, clamped to 0–100.
	pct(value: number): number {
		if (!this.total || this.total <= 0) return 0;
		return Math.min(100, Math.max(0, (value / this.total) * 100));
	}
}
